export default __webpack_public_path__ + "static/media/CVpolaroid_SmeatonsTower.ebf4e76d.png";